import React, { useState, useEffect } from "react";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const DatePickerComponent = (props) => {
  const [date, setDate] = useState(null);
  const { onChange, isOnlyDate, endDate, maxDate, minDate } = props;

  useEffect(() => {
    if (isOnlyDate) {
      onChange(date && date.valueOf() && date.toISOString().split('T')[0])
    } else {
      if (endDate) {
        date && date.setHours(23)
      } else {
        date && date.setHours(0, 0, 0, 0)
      }
      onChange(date && date.valueOf() && date.toISOString());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  let timeoutID = undefined;
  return (
    <DatePicker
      slotProps={{
        textField: {
          variant: 'standard',
          sx: { mr: 1, width: { xs: "100%", md: "140px" } },
          InputLabelProps: { shrink: true },
          inputProps: { "data-testid": "KeyboardDatePicker" }
        }
      }}
      value={date}
      maxDate={maxDate}
      minDate={minDate}
      onChange={(e) => {
        clearTimeout(timeoutID);
        timeoutID = setTimeout(() => {
          setDate(e);
        }, 200);
      }}
      label={props.label}
      disableToolbar={true}
      variant="inline"
      format="dd/MM/yyyy"
    />
  );
};

export default DatePickerComponent;
